import { render, staticRenderFns } from "./cliDetails.vue?vue&type=template&id=1853c76c&scoped=true&"
import script from "./cliDetails.vue?vue&type=script&lang=js&"
export * from "./cliDetails.vue?vue&type=script&lang=js&"
import style0 from "./cliDetails.vue?vue&type=style&index=0&id=1853c76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1853c76c",
  null
  
)

export default component.exports